const c = "style-module__checkboxInputLabel___8DE7Z", e = "style-module__checkboxChecked___lIf38", o = "style-module__checkbox___y03Nj", _ = "style-module__tickIcon___m5Sh3", t = {
  checkboxInputLabel: c,
  checkboxChecked: e,
  checkbox: o,
  tickIcon: _
};
export {
  o as checkbox,
  e as checkboxChecked,
  c as checkboxInputLabel,
  t as default,
  _ as tickIcon
};
